(function () {
  const CFG = window.FX;
  if (!CFG) return;

  const CACHE_KEY = 'fx-rates-v1';
  const TTL_MS = 60 * 60 * 1000;
  const ZERO_DECIMAL = ['JPY', 'KRW', 'TWD', 'IDR', 'HUF'];

  /* ---------- language selector: append currency hint ---------- */

  function labelSelector() {
    const links = document.querySelectorAll(
      '.language-selector a[data-value], #HeaderLanguageList a[data-value]'
    );

    links.forEach(function (link) {
      const currency = CFG.map[link.dataset.value];
      if (!currency) return;

      let hint = link.querySelector('.fx-lang-currency');
      if (!hint) {
        hint = document.createElement('span');
        hint.className = 'fx-lang-currency';
        link.appendChild(hint);
      }

      // Don't annotate the shop's own currency — "English USD" is noise.
      if (currency === CFG.shopCurrency) {
        hint.remove();
        return;
      }
      hint.textContent = currency;
    });
  }

  /* ---------- rates ---------- */

  async function getRates() {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        const c = JSON.parse(raw);
        if (Date.now() - c.storedAt < TTL_MS) return c.payload;
      }
    } catch (_) {}

    const res = await fetch(CFG.endpoint);
    if (!res.ok) throw new Error('fx http ' + res.status);

    const payload = await res.json();
    if (!payload || !payload.rates) throw new Error('fx malformed');

    try {
      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ storedAt: Date.now(), payload })
      );
    } catch (_) {}

    return payload;
  }

  function fmt(amount, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: ZERO_DECIMAL.includes(currency) ? 0 : 2
      }).format(amount);
    } catch (_) {
      return currency + ' ' + amount.toFixed(2);
    }
  }

  function paint(rate, currency, scope) {
    (scope || document).querySelectorAll('[data-fx-price]').forEach(function (el) {
      // Guard against double-converting if Shopify Markets is ever switched on
      // and cart.currency starts varying by locale.
      if (el.dataset.fxBase !== CFG.shopCurrency) return;

      const cents = parseInt(el.dataset.fxCents, 10);
      if (!Number.isFinite(cents)) return;

      const out = el.querySelector('[data-fx-approx]');
      if (!out) return;

      const prefix = currency === 'TWD' ? 'NT' : '';
      out.textContent = '≈ ' + prefix + fmt((cents / 100) * rate, currency);
      out.hidden = false;
    });
  }

  /* ---------- init ---------- */

  async function init() {
    labelSelector();

    // Country selector (if present) uses a <details> element.
    document.querySelectorAll('localization-form details').forEach(function (d) {
      d.addEventListener('toggle', labelSelector);
    });

    // Language selector uses a plain button toggling aria-expanded, not <details>,
    // so re-run the labeller when it's opened. Belt-and-suspenders: the full <ul>
    // is already in the DOM at load, so the initial labelSelector() usually covers it.
    document.querySelectorAll('.localization-selector').forEach(function (btn) {
      btn.addEventListener('click', function () {
        requestAnimationFrame(labelSelector);
      });
    });

    const currency = CFG.currency;
    if (!currency || currency === CFG.shopCurrency) return;

    let payload;
    try {
      payload = await getRates();
    } catch (_) {
      return; // silent fallback: the USD price stands on its own
    }

    const rate = payload.rates[currency];
    if (typeof rate !== 'number') return; // e.g. KRW not yet in the Worker

    paint(rate, currency);

    // Dawn swaps the whole price node on variant change.
    const root = document.querySelector('.product') || document.body;
    new MutationObserver(function (records) {
      for (const r of records) {
        for (const n of r.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.matches?.('[data-fx-price]') || n.querySelector?.('[data-fx-price]')) {
            paint(rate, currency, n.parentNode || document);
            return;
          }
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();